import React, {useEffect, useState} from 'react';

import ErrorComponent from '../inputComponentV2/components/errorComponent/errorComponent';
import InputTitleComponent from '../inputComponentV2/components/inputTitleComponent/inputTitleComponent';
import MultipleTextPillComponent from '../../../../scheduleComponents/multipleTextPillComponent/multipleTextPillComponent';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './emailInputComponent.css';

const EmailInputComponent = ({
  id = '',
  disableAdditionOfTextPills = false,
  showCustomError = false,
  initialEmails = [], // [{email: '', isValid: true}, ...],
  errorMessage = null,
  placeholder = '',
  titleTxt = '',
  toolTipTxt = '',
  onEmailsChanged = () => {},
}) => {
  const [recipients, setRecipients] = useState([]);
  const [recipientEmail, setRecipientEmail] = useState('');
  const [areAllEmailsValid, setAreAllEmailsValid] = useState(true);

  useEffect(() => {
    if (initialEmails && initialEmails.length) {
      setRecipients(initialEmails);
    }
  }, []);

  const setNewRecipientEmail = (email) => {
    setRecipientEmail(email);
  };

  const addRecipientEmail = () => {
    if (recipientEmail.length) {
      let tempRecipients = [...recipients];
      tempRecipients.push({
        email: recipientEmail,
        isValid:
          VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(recipientEmail),
      });
      setRecipients([...tempRecipients]);
      setRecipientEmail('');
      const areAllEmailsValid = areAllRecipientEmailsValid(tempRecipients);
      setAreAllEmailsValid(areAllEmailsValid);
      onEmailsChanged(id, tempRecipients, areAllEmailsValid);
    }
  };

  const editRecipientEmail = (idx, email) => {
    if (email.length === 0) {
      removeRecipient(idx);
    } else {
      let tempRecipients = [...recipients];
      tempRecipients[idx] = {
        email,
        isValid: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(email),
      };
      setRecipients([...tempRecipients]);
      const areAllEmailsValid = areAllRecipientEmailsValid(tempRecipients);
      setAreAllEmailsValid(areAllEmailsValid);
      onEmailsChanged(id, tempRecipients, areAllEmailsValid);
    }
  };

  const removeRecipient = (idx) => {
    let tempRecipients = [...recipients];
    tempRecipients.splice(idx, 1);
    setRecipients([...tempRecipients]);
    const areAllEmailsValid = areAllRecipientEmailsValid(tempRecipients);
    setAreAllEmailsValid(areAllEmailsValid);
    onEmailsChanged(id, tempRecipients, areAllEmailsValid);
  };

  const areAllRecipientEmailsValid = (recipients) => {
    if (recipients.length === 0) return false;
    return !recipients.find(
      (recipient) =>
        !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(recipient.email),
    );
  };

  return (
    <div className="et-v2-email-input-container">
      <InputTitleComponent titleTxt={titleTxt} toolTipTxt={toolTipTxt} />
      <div className="et-v2-eic-multiple-text-pills-wrap">
        <MultipleTextPillComponent
          disableAdditionOfTextPills={disableAdditionOfTextPills}
          showStatusIcon={false}
          recipients={recipients}
          newRecipientEmail={recipientEmail}
          placeholder={placeholder}
          showError={showCustomError || !areAllEmailsValid}
          setNewRecipientEmail={setNewRecipientEmail}
          addRecipientEmail={addRecipientEmail}
          editRecipientEmail={editRecipientEmail}
          removeRecipient={removeRecipient}
        />
      </div>
      {errorMessage && (showCustomError || !areAllEmailsValid) && (
        <ErrorComponent errorMessage={errorMessage} />
      )}
    </div>
  );
};

export default EmailInputComponent;
